/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCe = createReactComponent("outline", "ce", "IconCe", [["path", { "d": "M9 6a6 6 0 1 0 0 12", "key": "svg-0" }], ["path", { "d": "M21 6a6 6 0 1 0 0 12", "key": "svg-1" }], ["path", { "d": "M15 12h6", "key": "svg-2" }]]);

export { IconCe as default };
//# sourceMappingURL=IconCe.mjs.map
